import styled from "styled-components";
import { isMobile } from "react-device-detect";

type WrapperProps = {
  children: React.ReactNode;
};

const Wrapper = ({ children }: WrapperProps) => {
  return (
    <StyledWrapper>
      <WidthContainer>{children}</WidthContainer>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
  max-width: 100%;
`;

const WidthContainer = styled.div`
  position: "relative";
  width: ${isMobile ? "92%" : "80rem"};
  max-width: 100%;
  /* margin: 0 2rem; */
`;

export default Wrapper;
